<div class="p-0 m-0" *ngIf="!(loading$|async)">
    <ng-container *ngIf="valuation$ | async as valuation">
        <kt-comparables-map-v2 class="section-margin-bottom-60"
            [valuation]="valuation"
            [targetProperty]="targetProperty"
            [currentUser]="currentUser"
            ></kt-comparables-map-v2>
        <kt-comparables-table-v2
            [currentUser]="currentUser"
            [targetProperty]="targetProperty"
            (onAddComparable)="addComparable()"></kt-comparables-table-v2>
    </ng-container>
</div>